<!-- 商城隐私条例 -->
<template>
    <div class="agreement">
        <div class="h3">隐私条例（注册登录必选）</div>
        <div class="text">欢迎您使用“艺选”线上商城（以下简称“商城”）服务！本隐私条例是您注册、登录及使用商城服务的必选条款，旨在明确商城收集、使用、存储、保护及对外提供您个人信息的规则，保障您的个人信息安全及合法权益。请您仔细阅读并充分理解本条例全部内容，您点击“同意并注册/登录”，即表示您已知晓并同意本条例的全部约定，若您不同意本条例，将无法完成注册、登录及使用商城相关服务。</div>
        <div class="text">本条例严格遵循《中华人民共和国民法典》《中华人民共和国个人信息保护法》《网络安全法》等相关法律法规，参考国内成功线上商城（如京东、天猫）隐私保护实践，结合本商城自有供应链运营模式（供应链公司为商城运营主体自有，负责商品采购、仓储、配送、售后），兼顾合规性与实用性，明确双方权利义务。</div>
        <div class="h5">一、适用范围</div>
        <div class="text">1.1 本条例适用于所有通过商城APP、小程序、网页等渠道注册、登录及使用商城服务的用户（以下简称“用户”），包括普通消费者、平台代理商推广者、商品采购企业等。</div>
        <div class="text">1.2 本条例所指个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括但不限于姓名、手机号、身份证号、地址、联系方式、支付信息、浏览及消费记录等。</div>
        <div class="text">1.3 本条例不适用于商城第三方合作机构（除自有供应链公司外）的信息收集与使用行为，第三方合作机构的隐私规则由其自行制定，商城不承担相关责任，但会对第三方合作机构的信息使用行为进行必要监督。</div>
        <div class="h5">二、注册登录必选信息收集与使用</div>
        <div class="text">2.1 为完成注册登录、保障服务正常提供，商城将收集您的必选个人信息（不收集该类信息将无法完成注册登录，无法使用商城核心服务），收集范围及使用目的如下，全程遵循“最小必要”原则，不额外收集无关信息：</div>
        <div class="text">（1）手机号：用于注册账号、登录验证、身份核验、订单通知、售后沟通、安全提醒（如账号异常登录、交易异常），以及向您推送商城活动、商品上新等相关信息（您可在后续设置中关闭营销推送）；</div>
        <div class="text">（2）验证码：用于验证您的手机号真实性，确保账号归属权，防范账号被盗、恶意注册等风险，验证码仅用于本次注册登录验证，验证完成后自动失效，不存储完整验证码信息；</div>
        <div class="text">（3）账号密码/登录凭证（如微信、支付宝快捷登录）：用于账号登录身份确认，保障账号安全，商城将对密码进行加密存储，不存储明文密码；快捷登录将通过第三方平台授权完成，商城不获取第三方平台的账号密码等核心信息；</div>
        <div class="text">（4）用户昵称：用于商城内身份标识、订单展示、评论互动等，您可自行设置，昵称需符合商城规则，不得包含违法违规、低俗色情等内容。</div>
        <div class="text">2.2 额外信息收集说明：除上述必选信息外，商城可能根据您使用服务的需求（如购物、售后、推广等），额外收集您的姓名、收货地址、身份证号、支付信息、浏览记录、消费记录等信息，该类信息为非必选，您可选择是否提供，不提供不影响基础注册登录服务，但可能无法使用购物、下单、售后等延伸服务。</div>
        <div class="text">2.3 信息使用限制：商城收集的个人信息仅用于本条例约定的用途，不得用于超出约定范围的用途，未经您的明确同意，不得将个人信息用于其他目的；结合商城自有供应链模式，您的订单信息（含收货地址、商品需求）将同步至商城自有供应链公司，用于商品采购、仓储、配送及售后对接，供应链公司需严格遵守本条例约定，对您的个人信息承担保密责任，不得擅自泄露或用于其他用途。</div>
        <div class="h5">三、个人信息存储与保护</div>
        <div class="text">3.1 存储方式：商城将您的个人信息存储在符合国家法律法规要求的服务器中，采用加密技术（如SSL加密、数据脱敏）对个人信息进行保护，防止信息泄露、篡改、丢失；存储服务器位于中国境内，不擅自将个人信息存储至境外服务器。</div>
        <div class="text">3.2 存储期限：商城将按照“留存必要最短期限”原则存储您的个人信息，您的注册登录信息（手机号、账号密码加密信息）将在您账号存续期间留存；订单、消费等信息将留存至订单完成后3年，用于售后维权、纠纷处理及合规备案；超出存储期限的个人信息，将自动进行匿名化处理或删除，无法识别您的身份。</div>
        <div class="text">3.3 保护措施：商城建立完善的个人信息安全管理制度，配备专业的安全技术人员，定期对服务器、系统进行安全检测、升级，防范网络攻击、病毒入侵等风险；限制内部人员访问个人信息的权限，对访问人员进行身份验证及行为记录，严禁内部人员擅自查看、泄露、篡改个人信息；商城自有供应链公司及内部员工均需签署保密协议，对您的个人信息承担保密责任，若违反约定将承担相应的法律责任。</div>
        <div class="text">3.4 安全提示：请您妥善保管您的账号密码、验证码等登录凭证，不要向他人泄露，若发现账号异常登录、信息泄露等情况，请及时联系商城客服，商城将及时采取冻结账号、修改密码等措施，降低您的损失。</div>
        <div class="h5">四、个人信息对外提供与共享</div>
        <div class="text">4.1 原则：商城不会擅自将您的个人信息对外提供、共享给任何第三方，除以下法定或约定情形外，未经您的明确同意，不向任何第三方泄露您的个人信息：</div>
        <div class="text">（1）商城自有供应链公司：为完成商品采购、仓储、配送、售后等服务，商城将您的订单信息、收货地址、联系方式等必要信息同步给自有供应链公司，供应链公司仅用于履约服务，不得用于其他目的，且需严格遵守本条例的隐私保护要求；</div>
        <div class="text">（2）法定情形：为遵守国家法律法规、行政机关指令（如公安、税务、市场监管等部门的合法查询要求），或为维护商城、用户及社会公共利益，在必要范围内提供您的个人信息；</div>
        <div class="text">（3）第三方服务提供商：为提供支付、物流、技术支持等服务，商城可能将您的相关信息（如支付信息、收货地址）共享给具备合法资质的第三方服务提供商（如银行、快递公司、技术服务商），第三方服务提供商需严格遵守保密约定，不得擅自泄露或滥用您的个人信息，商城将对第三方服务提供商的行为进行监督；</div>
        <div class="text">（4）匿名化处理：商城可将经过匿名化处理、无法识别您身份的信息（如消费趋势、商品偏好等）用于市场分析、平台优化、活动策划等，该类匿名化信息不属于个人信息，可自由使用及共享。</div>
        <div class="text">4.2 共享限制：商城与第三方共享您的个人信息时，将明确双方的权利义务，要求第三方采取相应的安全保护措施，确保您的个人信息安全；若第三方违反约定，泄露您的个人信息，商城将追究其违约责任，若给您造成损失，将依法承担相应的赔偿责任。</div>
        <div class="h5">五、用户的权利</div>
        <div class="text">根据相关法律法规，您对您的个人信息享有以下权利，商城将为您提供便捷的权利行使渠道：</div>
        <div class="text">5.1 访问权：您可登录商城账号，在“个人中心-隐私设置”中，查看您的个人信息（如注册手机号、昵称、订单记录等）；</div>
        <div class="text">5.2 更正权：若您发现您的个人信息存在错误（如昵称、收货地址等），可自行在商城账号中修改，或联系客服协助更正；</div>
        <div class="text">5.3 删除权：您可申请删除您的个人信息（如收货地址、浏览记录等），若符合删除条件，商城将在15个工作日内完成删除；但用于合规备案、纠纷处理等必要留存的信息，将不予删除，仍按本条例约定存储；</div>
        <div class="text">5.4 账号注销权：您可申请注销商城账号，账号注销后，商城将停止对您个人信息的收集、使用，对您的个人信息进行匿名化处理或删除（留存必要合规信息除外），账号注销后无法恢复，请您谨慎操作；</div>
        <div class="text">5.5 异议权：若您认为商城收集、使用、存储您个人信息的行为违反本条例或相关法律法规，可向商城客服提出异议，商城将在10个工作日内予以回复并处理；</div>
        <div class="text">5.6 撤回同意权：您可随时撤回对本条例的同意，或撤回对额外信息收集、营销推送等的同意，撤回同意后，商城将停止相关信息的收集、使用，但不影响撤回前已完成的信息收集及使用行为的合法性，且可能影响您使用商城的部分延伸服务。</div>
        <div class="h5">六、未成年人隐私保护</div>
        <div class="text">6.1 商城不鼓励未成年人（未满18周岁）注册使用商城服务，若未成年人需使用商城服务，必须在其法定监护人的同意及指导下进行，法定监护人需承担相应的监护责任。</div>
        <div class="text">6.2 若未成年人注册使用商城服务，其法定监护人应协助其阅读本条例，明确相关权利义务，商城仅收集未成年人的必要信息（如手机号，由法定监护人提供），不收集与服务无关的信息，且将采取更严格的保护措施，防止未成年人信息泄露。</div>
        <div class="text">6.3 法定监护人可向商城申请查询、更正、删除未成年人的个人信息，商城将积极配合，保障未成年人的隐私权益。</div>
        <div class="h5">七、隐私条例的变更与通知</div>
        <div class="text">41.1 因国家法律法规更新、商城服务升级、运营模式调整等原因，本隐私条例可能会进行修订，修订后的条例将在商城APP、小程序等显著位置进行公示，公示期限不少于7个工作日。</div>
        <div class="text">41.2 修订后的隐私条例自公示期满后生效，若您继续使用商城注册登录及相关服务，即表示您已接受修订后的条例；若您不同意修订后的条例，可停止使用商城服务，申请注销账号。</div>
        <div class="text">41.3 若本条例的变更涉及您的核心权利（如必选信息收集范围、信息对外提供规则等），商城将通过您注册的手机号、商城消息等方式，单独向您发送通知，确保您知晓变更内容。</div>
        <div class="h5">八、免责条款</div>
        <div class="text">45.1 因不可抗力（如地震、洪水、台风、战争、网络中断、政府政策调整等）导致您的个人信息泄露、丢失、篡改，商城不承担责任；</div>
        <div class="text">45.2 因您自身操作不当（如泄露账号密码、验证码，点击陌生链接，向第三方泄露个人信息等）导致的个人信息泄露、账号被盗等损失，商城不承担责任；</div>
        <div class="text">45.3 第三方服务提供商、商城自有供应链公司违反保密约定，擅自泄露您的个人信息，由该第三方承担主要责任，商城在自身过错范围内承担补充责任；</div>
        <div class="text">45.4 商城在合理范围内履行了隐私保护义务，因不可归责于商城的原因（如网络攻击、黑客入侵等）导致的个人信息安全问题，商城不承担责任。</div>
        <div class="h5">九、争议解决</div>
        <div class="text">50.1 本隐私条例的履行过程中发生的争议，双方应首先友好协商解决；协商不成的，任何一方均有权向商城运营主体所在地有管辖权的人民法院提起诉讼。</div>
        <div class="text">50.2 争议解决期间，除争议事项外，双方应继续履行本条例的其他约定，商城将继续履行个人信息保护义务。</div>
        <div class="h5">十、其他</div>
        <div class="text">53.1 本隐私条例是商城注册登录的必选条款，与商城的其他服务条款、规则具有同等法律效力，若本条例与其他条款不一致，以本条例为准。</div>
        <div class="text">53.2 您若对本隐私条例有任何疑问、意见或投诉，可通过商城客服渠道（联系方式：425214234@qq.com联系我们，商城将及时为您解答及处理。</div>
        <div class="text">53.3 本隐私条例自您点击“同意并注册/登录”之日起生效，对您及商城均具有法律约束力。</div>
        <div class="text">“艺选”线上商城运营主体：_嘉万艺（重庆）科技有限公司</div>
        <div class="text">日期：2026年4月14日</div>
    </div>
</template>

<script>
export default {
    setup() {
    }
}
</script>
<style scoped>
.agreement{
    padding: 0 15px 20px;
}
.h3{
    font-size: 20px;
    margin: 10px 0;
    text-align: center;
    font-weight: 600;
    line-height: 1.5;
}
.agreement .h5{
    font-size: 18px;
    font-weight: 600;
    margin: 14px 0 8px;
}
.text{
    font-size: 16px;
    text-indent: 34px;
    line-height: 1.65;
    margin-bottom: 6px;
}
</style>
